import gql from 'graphql-tag';

export default gql`
  fragment contentAudioFragment on ContentAudio {
    id
    uuid
    file
    fileName
    fileContentType
    fileSize
    memo
    createdAt
    updatedAt
  }
`;
